import { render, staticRenderFns } from "./ToBeAssign.vue?vue&type=template&id=5d76337b"
import script from "./ToBeAssign.vue?vue&type=script&lang=js"
export * from "./ToBeAssign.vue?vue&type=script&lang=js"
import style0 from "./ToBeAssign.vue?vue&type=style&index=0&id=5d76337b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports